import { Gamepad2, Swords, Crown, Target, Zap, Trophy, Globe, Rocket, Car, Flame, Smartphone, MoreHorizontal } from "lucide-react";
import { cn } from "@/lib/utils";
import { GAME_CATEGORIES, getGameByID } from "@/lib/gameCategories";

interface GameTabsProps {
  activeGame: string;
  onGameChange: (game: string) => void;
}

// Map game IDs to icons
const gameIcons: Record<string, any> = {
  "cs2": Target,
  "dota2": Swords,
  "lol": Crown,
  "valorant": Zap,
  "fortnite": Gamepad2,
  "overwatch": Trophy,
  "apex": Flame,
  "rocketleague": Car,
  "smash": Gamepad2,
  "fgc": Trophy,
  "mobile": Smartphone,
  "other": MoreHorizontal,
};

const games = [
  { id: "all", name: "All Games", icon: Globe, code: "ALL" },
  ...GAME_CATEGORIES.map(game => ({
    id: game.id,
    name: game.name,
    icon: gameIcons[game.id] || Gamepad2,
    code: game.code
  }))
];

export function GameTabs({ activeGame, onGameChange }: GameTabsProps) {
  return (
    <div className="flex items-center gap-0 overflow-x-auto border-b border-border [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
      {games.map((game) => {
        const Icon = game.icon;
        const isActive = activeGame === game.id;
        
        return (
          <button
            key={game.id}
            onClick={() => onGameChange(game.id)}
            className={cn(
              "flex items-center gap-2 px-4 py-3 transition-all shrink-0 relative",
              isActive
                ? "text-primary"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            <Icon className="h-4 w-4" />
            <span className="font-medium text-sm whitespace-nowrap">
              {game.name}
            </span>
            {isActive && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" />
            )}
          </button>
        );
      })}
    </div>
  );
}

